import React from 'react';
import {t, Trans} from '@lingui/macro';
import {Input, Tag} from "antd";
import BatchInvoicingActions from 'bukku/redux/BatchInvoicing/actions';
import AssetActions from 'bukku/redux/Asset/actions';

export const LockAccountingPeriodInfo = {
    title: () => t`Accounting Period Locked`,
    onOk: (passcode, handleOk, action) => {
        if (passcode) {
            const newAction = {...action};

            // all batch transactions
            if (action.type === BatchInvoicingActions.BATCH_INVOICING_CREATE_REQUEST) {
                newAction.period_lock_passcode = passcode;
                handleOk(newAction);
            }

            else if (action.type === AssetActions.ASSET_DELETE_REQUEST) {
                newAction.period_lock_passcode = passcode;
                handleOk(newAction);
            }

            // normal transaction create
            else {
                if (!newAction.request)
                    newAction.request = {};

                newAction.request.period_lock_passcode = passcode;
                handleOk(newAction);
            }
        }
    },
    bodyStyle: {},
    noPasscode: false,
};

function LockAccountingPeriod(props) {
    // Redux
    const { message, passcode, setPasscode, passcodeRef } = props;

    return (
        <>
            <div style={{marginBottom: 16}}>
                <Trans>
                    Please provide the&nbsp;
                    <Tag>Lock Accounting Period</Tag>
                    passcode to proceed.
                </Trans>
            </div>
            <Input.Password
                ref={passcodeRef}
                addonBefore={t`Passcode`}
                type="number"
                value={passcode}
                onChange={e => setPasscode(e.target.value)}
                // onPressEnter={() => LockAccountingPeriodInfo.onOk(passcode, handleOk, action)}
                placeholder="####"
            />
            { message ? <div style={{marginTop: 16, color: "#ff4d4f"}}>{message}</div> : null}
        </>
    );
}

export default LockAccountingPeriod;
